export const getPodFormValidateDelay = (length: number) => {
  return length > 10 ? 700 : length > 6 ? 500 : 200
}

export const getPodFromFillDuplicatesDelay = (length: number) => {
  return length > 10 ? 500 : length > 6 ? 300 : 100
}